var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentsOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stickersheets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleguide-/-Logo-/-Colors-/-Typography-/-Buttons-/-Icons-/-Inputs-/-Loaders-/-Checkboxes-/-Tabs-/-Pagination-/-Lables-",
    transform: "translate(-404.000000, -2456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-comments-ea57-on",
    transform: "translate(404.000000, 2456.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.500000, 1.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25,6 L12.75,6 L12.75,12.75 L3,12.75 L3,14.25 C3,14.6625 3.3375,15 3.75,15 L12,15 L15,18 L15,6.75 C15,6.3375 14.6625,6 14.25,6 Z M11.25,10.5 L11.25,3.75 C11.25,3.3375 10.9125,3 10.5,3 L0.75,3 C0.3375,3 0,3.3375 0,3.75 L0,14.25 L3,11.25 L10.5,11.25 C10.9125,11.25 11.25,10.9125 11.25,10.5 Z",
    id: "Shape",
    fill: "#283049",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "#C3E27A",
    cx: 13.5,
    cy: 3.75,
    r: 3.75
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsOn);
export default __webpack_public_path__ + "static/media/comments-on.a0ed8450.svg";
export { ForwardRef as ReactComponent };